import useIntakeData from '../../../../../services/intakeDataService';
import type { useIntakeBlockToggleValue } from './types';
import { intakeConfigBlock } from './types';

export const intakeBlocksEnum = { ...intakeConfigBlock };

export default function useIntakeBlockToggle(): useIntakeBlockToggleValue {
  const { data } = useIntakeData();

  return {
    isOn(value) {
      return !!data?.config?.blocks.find((block) => block.name === value);
    },
    isRequired(value) {
      return !!data?.config?.blocks.find((block) => block.name === value)?.isRequired;
    },
  };
}
